import { type CustomFieldTypeEnum } from './CustomFieldTypes'

export interface CustomFieldConstructorData {
  id: number
  name: string
  type: CustomFieldTypeEnum
  choices: string[]
  required: boolean
  active: boolean
}

export class CustomField {
  id: number
  name: string
  type: CustomFieldTypeEnum
  choices: string[]
  required: boolean
  active: boolean

  constructor(data: CustomFieldConstructorData) {
    this.id = data.id
    this.name = data.name
    this.type = data.type
    this.choices = data.choices
    this.required = data.required
    this.active = data.active
  }
}
